import { ActionIcon, Box, Button, Group, Loader, Paper, Text, TextInput } from "@mantine/core";
import { useHover } from "@mantine/hooks";
import { IconCopy } from "@tabler/icons-react";
import { ChatModel } from "./ChatResultModel";
import { useState } from "react";
import { useForm } from "@mantine/form";

export function ChatRequestCard(props: { chatModel: ChatModel, onReload?: () => void, onEditText?: (v: string) => void }) {
    const { hovered: request_hovered, ref: request_ref } = useHover();
    const [editing, setEditing] = useState(false)
    const form = useForm({
        initialValues: {
            editText: '',
        }
    });
    return <>
        {props.chatModel.requestText !== undefined &&
            <Box ref={request_ref} pos="relative" display="inline-flex" pb={20} style={{ justifyContent: "end" }} >
                {editing ?
                    <>
                        <Paper w="100%" radius="lg" p="lg">
                            <form onSubmit={form.onSubmit((values) => {
                                props.onEditText?.(values.editText)
                                setEditing(false)
                            })}>
                                <TextInput
                                    variant="unstyled"
                                    placeholder="修改訊息"
                                    radius="md"
                                    {...form.getInputProps('editText')}
                                />
                                <Group gap={5} justify="end">
                                    <Button radius="xl" color="gray" onClick={() => setEditing(false)}>取消</Button>
                                    <Button radius="xl" type="submit">傳送</Button>
                                </Group>
                            </form>
                        </Paper>
                    </>
                    :
                    <>
                        <Paper p="md" radius="xl" bg="#AD784C33" >
                            <Text size="md" c="#FAFAFA">{props.chatModel.requestText}</Text>
                        </Paper>
                        {/* <Group gap={0} display={request_hovered && !props.chatModel.responseLoading ? "block" : "none"} pos="absolute" bottom={-5} >
                            <ActionIcon variant="transparent" onClick={() => {
                                form.setFieldValue("editText", props.chatModel.requestText ?? "")
                                setEditing(true)
                            }}>
                                <IconEdit style={{ width: '70%', height: '70%' }} stroke={1.5} />
                            </ActionIcon>
                            <ActionIcon variant="transparent" onClick={props.onReload}>
                                <IconReload style={{ width: '70%', height: '70%' }} stroke={1.5} />
                            </ActionIcon>
                        </Group> */}
                    </>
                }
            </Box>
        }
        <Box pos="relative" display="inline-flex" style={{ flexDirection: "column" }} >
            <Paper p="md" bg="#FFFFFF0D" radius="xl">
                {/* <Group gap={0}>

                    <Group gap={0}>
                        <Text c="#FAFAFA" size="sm">AI Bot</Text>
                    </Group>

                </Group> */}
                {props.chatModel.responseFail ? <Text size="md" c="red" style={{ whiteSpace: "pre-wrap" }}>
                    發生錯誤:
                    <br />
                    {props.chatModel.responseFailMsg}
                </Text> : props.chatModel.responseLoading ? <Loader size="sm" type="dots" color={"#FAFAFA"} /> :
                    <>
                        <Text size="md" style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }} c="#FAFAFA">{props.chatModel.response.text}</Text>
                    </>
                }
            </Paper>
            <Group gap={0} >
                <ActionIcon variant="transparent" onClick={() => {
                    props.chatModel.response.text && navigator.clipboard.writeText(props.chatModel.response.text);
                }}>
                    <IconCopy style={{ width: '70%', height: '70%' }} stroke={1.5} color={"#FAFAFA"} />
                </ActionIcon>
            </Group>
        </Box>
    </>

}